import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServiceToken, ServiceTokenService } from 'onevoice';

@Component({
  selector: 'alabia-token-dialog',
  templateUrl: './token-dialog.component.html',
  styleUrls: ['./token-dialog.component.scss']
})
export class TokenDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ServiceToken,
    private service: ServiceTokenService,
  ) {
  }

  ngOnInit() {
  }

}
